import React from "react";

const venueContext = React.createContext(); // Create a context object

// Export it so it can be used by other Components;
export default venueContext;
